<template>
    <button
        v-if="copyInputId"
        :title="textTitle"
        :data-confirm="textConfirm"
        :at-a-button-copy="atAttribute"
        type="button"
        class="a-button-copy button-copy"
        @click="copyInputValue($event, copyInputId)"
    >
        <span class="icon icon-copy" />
    </button>
</template>

<script>
import { locale } from './../../../utils/services/localization-service';

export default {
    name: 'AButtonCopy',
    props: {
        /**
         * Set title text
         */
        textTitle: {
            type: String,
            default: 'copy_text_title'
        },
        /**
         * Set confirm text
         */
        textConfirm: {
            type: String,
            default: 'copy_text_confirm'
        },
        /**
         * ID of target input to copy
         */
        copyInputId: {
            type: String,
            default: ''
        },
        /**
         * locator for automation testing
         */
        atAttribute: {
            type: String,
            default: ''
        }
    },
    methods: {
        locale(key) {
            return locale(key);
        },
        copyInputValue(event, inputId) {
            let button = event.target;
            if (!event.target.classList.contains('button-copy')) {
                button = event.target.closest('.button-copy')
            }
            // TODO: separate flow in to clipboard-service
            const input = document.getElementById(inputId);
            if (!input) return;
            const activeClassName = 'button-copy--active';
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand('copy');

            button.classList.add(activeClassName);
            setTimeout(() => {
                button.classList.remove(activeClassName);
            }, 750)
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
